import { render, staticRenderFns } from "./deliverTask.vue?vue&type=template&id=6dba624a&scoped=true"
import script from "./deliverTask.vue?vue&type=script&lang=js"
export * from "./deliverTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dba624a",
  null
  
)

export default component.exports